<template>
  <v-card class="fpv-reports-table">
    <v-card-title>
      <v-spacer />
      <v-spacer />
      <v-text-field
        v-model="search"
        flat
        append-icon="search"
        label="Search by user_id"
        single-line
        hide-details
      />
    </v-card-title>
    <v-tooltip
      top
      dark
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="secondary"
          fab
          dark
          absolute
          top
          right
          @click.stop="openFpvReportModal"
          v-on="on"
        >
          <v-icon>note_add</v-icon>
        </v-btn>
      </template>
      <span>Trigger FPV-Reports</span>
    </v-tooltip>
    <v-data-table
      :headers="headers"
      :items="fpvReports"
      :loading="loading"
      :expand="false"
      item-key="date_of_creation"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr
          :active="props.selected"
          @click="props.expanded = !props.expanded"
        >
          <td>
            {{ props.item.fpv_quarter_id }}
          </td>
          <td>
            {{ props.item.user_id }}
          </td>
          <td>
            {{ props.item.document_id }}
          </td>
          <td>
            {{ props.item.file_name }}
          </td>
          <td>
            {{ props.item.strategy_id }}
          </td>
          <td>
            {{ props.item.brand }}
          </td>
          <td>
            {{ props.item.date_of_creation }}
          </td>
          <td>
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  color="warning"
                  class="action-button"
                  flat
                  icon
                  v-on="on"
                  @click="download(props.item)"
                >
                  <v-icon>cloud_download</v-icon>
                </v-btn>
              </template>
              <span>download</span>
            </v-tooltip>
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  color="blue"
                  class="action-button"
                  flat
                  icon
                  v-on="on"
                  @click="preview(props.item)"
                >
                  <v-icon>preview</v-icon>
                </v-btn>
              </template>
              <span>preview</span>
            </v-tooltip>
            <v-tooltip
              v-if="isPreview"
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  class="action-button"
                  color="green"
                  flat
                  icon
                  v-on="on"
                  @click="toggleActionModalOpen('approve', props.item)"
                >
                  <v-icon>check</v-icon>
                </v-btn>
              </template>
              <span>approve</span>
            </v-tooltip>
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  color="red"
                  class="action-button"
                  flat
                  icon
                  v-on="on"
                  @click="toggleActionModalOpen('decline', props.item)"
                >
                  <v-icon>cancel</v-icon>
                </v-btn>
              </template>
              <span>decline</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog
      v-model="modalActionOpen"
      width="400"
      persistent
    >
      <v-card>
        <v-card-title
          :class="action"
        >
          <span class="white--text">
            Please confirm to {{ action }} report(s) with the quarter id "{{ selectedFpvReport ? selectedFpvReport.fpv_quarter_id : '' }}"
          </span>
        </v-card-title>
        <v-alert
          v-if="error"
          type="error"
          :value="true"
        >
          {{ error }}
        </v-alert>
        <v-form
          @submit.prevent="submitAction"
        >
          <v-card-actions>
            <v-spacer />
            <v-btn
              flat
              @click="toggleActionModalOpen"
            >
              Close
            </v-btn>
            <v-btn
              v-if="action === 'decline'"
              color="deep-orange darken-4"
              flat
              type="submit"
            >
              {{ action }}
            </v-btn>
            <v-btn
              v-if="action === 'approve'"
              color="green darken-4"
              flat
              type="submit"
            >
              {{ action }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <trigger-fpv-reports
      :dialog="triggerFpvReportModal"
      :submit-action="triggerFpvReportCall"
      :cancel-action="closeFpvReportModal"
      :error="triggerError"
    />
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import { formatDateSmall } from '@/utils/dateFormats';
import { setQuery } from '@/helpers';
import TriggerFpvReports from '@/components/roboInvesting/dialogs/TriggerFpvReports';

export default {
  name: 'FpvReportsTable',
  components: {
    TriggerFpvReports,
  },
  props: {
    fpvReports: {
      type: Array,
      default: () => [],
    },
    isPreview: {
      type: Boolean,
      default: true,
    },
    refreshFunction: {
      type: Function,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isLoadTableData: false,
      search: undefined,
      modalActionOpen: false,
      triggerFpvReportModal: false,
      selectedFpvReport: undefined,
      error: '',
      triggerError: '',
      action: '',
      filters: {
        createdAt: [],
        state: [],
      },
      headers: [
        {
          text: 'Quarter Id',
          align: 'left',
          value: 'fpv_quarter_id',
        },
        {
          text: 'User Id',
          align: 'left',
          value: 'user_id',
        },
        {
          text: 'Document Id',
          align: 'left',
          value: 'document_id',
        },
        {
          text: 'File Name',
          align: 'left',
          value: 'file_name',
        },
        {
          text: 'Strategy Id',
          align: 'left',
          value: 'strategy_id',
        },
        {
          text: 'Brand',
          align: 'left',
          value: 'brand',
        },
        {
          text: 'Date of Creation',
          align: 'left',
          value: 'date_of_creation',
        },
        {
          text: 'Actions',
          align: 'left',
          value: 'actions',
        },
      ],
      formatDateSmall,
    };
  },
  watch: {
    search: {
      immediate: false,
      handler(search, oldSearch) {
        if (search !== oldSearch) {
          setQuery(
            {
              search,
            },
            this.$route,
            this.$router,
          );
          this.refreshFunction(search);
        }
      },
    },
  },
  methods: {
    ...mapActions(['downloadFile', 'fpvReportActionCall', 'getOpenFpvReports', 'getApprovedFpvReports', 'triggerFpvReports']),
    async preview(document) {
      this.downloadFile({
        userId: document.user_id,
        documentId: document.document_id,
      }).then((response) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        window.open(window.URL.createObjectURL(blob));
      });
    },
    async download(file) {
      this.downloadFile({
        userId: file.user_id,
        documentId: file.document_id,
      }).then((response) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = file.file_name;
        link.click();
      });
    },
    async fpvReportAction(action) {
      await this.fpvReportActionCall({
        fpvQuarterId: this.selectedFpvReport.fpv_quarter_id,
        action,
      });
      this.modalActionOpen = false;
      await this.getOpenFpvReports();
      await this.getApprovedFpvReports();
    },
    toggleActionModalOpen(action = '', fpvReport) {
      this.error = '';
      this.action = action;
      this.selectedFpvReport = fpvReport;
      this.modalActionOpen = !this.modalActionOpen;
    },
    submitAction() {
      switch (this.action) {
        case 'approve':
          this.fpvReportAction('approve');
          break;
        case 'decline':
          this.fpvReportAction('decline');
          break;
        default:
          break;
      }
    },
    closeFpvReportModal() {
      this.triggerFpvReportModal = false;
      this.triggerError = '';
    },
    openFpvReportModal() {
      this.triggerFpvReportModal = true;
    },
    async triggerFpvReportCall(data) {
      try {
        const response = await this.triggerFpvReports(data);
        if (response.status !== 200) {
          this.triggerError = response.message;
        } else {
          this.triggerFpvReportModal = false;
        }
      } catch (e) {
        this.triggerError = `Fehler beim FpvReport-Trigger: ${e}`;
        this.triggerFpvReportModal = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fpv-reports-table{
  a {
    text-decoration: none;
    color: black;
  }
  .infoLabel {
    margin-left: 16px;
  }
  .countLabel {
    color: #fff;
  }
  .expanded-details {
    background-color: #eaeaea;
    padding: 20px;
  }
  .v-select{
    flex: 1;
  }
  table.v-table {
    td:not(:first-child),
    th:not(:first-child) {
      padding: 0 1% !important;
    }
  }
  .v-card__title.subheading{
    .v-icon{
      margin-right:10px;
    }
  }
  .v-input{
    &.security_wallet{
      min-width: 350px;
    }
  }
}
.decline {
  background-color: #bf360c;
}
.approve {
  background-color: #1B5E20;
}
.trigger {
  background-color: coral;
}
.action-button {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/roboInvesting/FpvReportsTable.vue